export default __webpack_public_path__ + "static/media/pGroup.bab12163.png";